import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getFormattedDateWithTime,
  getDateFromNow,
  getDisplayAmlFlow,
} from '@/helpers';
import { AmlHistoryItemData } from '@/redux/models';
import { Button, SvgIcon } from '@/components';

import styles from './CheckMadeOn.module.sass';

interface CheckMadeOnProps {
  isLoading?: boolean;
  item: AmlHistoryItemData;
  isPromo?: boolean;
  checkAgainHandler: () => void;
}

const CheckMadeOn: FC<CheckMadeOnProps> = (props) => {
  const { item, isPromo, checkAgainHandler, isLoading } = props;
  const { t } = useTranslation();

  const checkedFromNow = useMemo(
    () => getDateFromNow(item?.updated_at),
    [item],
  );

  const lastChecked = useMemo(
    () => getFormattedDateWithTime(item?.updated_at),
    [item],
  );

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonButton} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.box}>
      <div className={styles.date}>
        <div className={styles.date__title}>
          {t('translation.last_checked_title')}
        </div>
        <table className={styles.date__list}>
          <tbody>
            <tr>
              <td>{t('translation.check_cost_note')}</td>
              <td>
                <span>
                  {item.cost > 0 ? (
                    <>
                      {item.cost}
                      <SvgIcon name="aml" />
                    </>
                  ) : (
                    t('translation.check_for_free_btn')
                  )}
                </span>
              </td>
            </tr>
            <tr>
              <td>{t('translation.amlflow_title')}</td>
              <td>
                <span>{getDisplayAmlFlow(item.flow)}</span>
              </td>
            </tr>
            <tr>
              <td>{t('translation.last_checked_title')}</td>
              <td>
                <span>{checkedFromNow}</span>
              </td>
            </tr>
            <tr>
              <td>{t('translation.last_checked_stamp')}</td>
              <td>
                <span>{lastChecked}</span>
              </td>
            </tr>
          </tbody>
        </table>

        {!isPromo && (
          <div className={styles.date__actions}>
            <Button
              type="primary-black"
              size="s"
              corner="rect"
              onClick={checkAgainHandler}
            >
              {t('translation.check_again_btn')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckMadeOn;
